import React from "react";
import { Modal, Button, Row, ConfigProvider, Image } from "antd";
import ic_profile_learner_attendance from '../assets/images/svgs/ic_profile_learner_attendance.svg';

import {
  textTitleMyLearningJourney,
  ColorPrimary,
  textDescPlayModule,
  textAlertQuit,
} from "../config/constant/color/index";


// for translate
import { useTranslation } from "react-i18next";

const ModalConfirmAdmission = ({
    setUseridCheckin,
    setUserFullnameCheckin,
    submitCheckinUser,
    useridCheckin,
    userFullnameCheckin,
    statusCheckin,
    loadingPushWs
}) => {
  const { t, i18n } = useTranslation();


  return(
    <ConfigProvider
      theme={{
        components: {
          Modal: {
            borderRadiusLG: "16px",
            borderRadiusSM: "16px",
            borderRadiusXS: "16px",
          },
        },
        token: {
          borderRadiusLG: 28,
          fontFamily: "Roboto",
          motionDurationMid: "0.2s",
        },
      }}
    >
        <Modal
            className="modal-confirm-admission"
            open={!loadingPushWs && (useridCheckin !== undefined ? statusCheckin === undefined ? true : false : false)}
            maskClosable="false"
            closeIcon={false}
            width={424}
            transitionName="ant-fade"
            keyboard
            centered
            footer={
              <Row
                style={{
                  justifyContent: "space-between",
                  padding: "0 32px 32px",
                  gap: "0px",
                  flexWrap: "unset",
                }}
              >
                <Button
                  key="no-logout"
                  className="btn btn-sm btn-secondary"
                  style={{
                    width: "170px",
                    borderRadius: "6px",
                    border: "1px solid " + ColorPrimary,
                    fontWeight: "500",
                    height: "48px",
                  }}
                  name="btn-cancel-logout-home"
                  onClick={() => {
                    setUseridCheckin(undefined)
                    setUserFullnameCheckin(undefined)
                  }}
                >
                  {t("feature.feature_scanner.no")}
                </Button>
                <Button
                  key="yes-logout"
                  className="btn btn-sm btn-secondary"
                  style={{
                    width: "170px",
                    borderRadius: "6px",
                    border: "1px solid " + ColorPrimary,
                    fontWeight: "500",
                    height: "48px",
                  }}
                  name="btn-yes-confirmation-admission"
                    onClick={() => submitCheckinUser(useridCheckin)}
                >
                  {t("feature.feature_scanner.yes")}
                </Button>
              </Row>
            }
          >
            <div
              style={{
                textAlign: "center",
                marginBottom: "23px",
                padding: "29px 32px 0",
              }}
            >
              <p
                style={{
                  color: textTitleMyLearningJourney,
                  margin: 0,
                }}
              >
                <Row style={{justifyContent:"center"}}>
                    <Image width={60} height={60} preview={false} src={ic_profile_learner_attendance} alt="icon check attendace" />
                </Row>
                <Row style={{fontSize:14,marginTop:24,justifyContent:"center"}}>
                    <div>{t("feature.feature_scanner.is_attend")} <span style={{color:"#2488FF",fontWeight:"bold"}}>{userFullnameCheckin}</span> {t("feature.feature_scanner.attended")}</div>
                    <div>{t("feature.feature_scanner.please_confirm")}</div>
                </Row>
              </p>
            </div>
          </Modal>
    </ConfigProvider>
  )
}

export default ModalConfirmAdmission;